module.exports = __webpack_public_path__ + "static/media/sense4215.39466118.jpg";